// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'PVT',
  endpoint_newmcadm: 'https://dev-newmcadm.cdc.ais.th/',
  baseUrl: 'https://dev-newmcadm.cdc.ais.th/',
  idsApplicationName: 'MCADMIN For Dev',
  idsLogin:{
    baseUrl:'https://test-ids.ais.co.th/oauth2/authorize?',
    logOut:"https://test-ids.ais.co.th/oidc/logout?",
    redirect_url:'https://dev-newmcadm.cdc.ais.th/callback-signin',
    channels: {
      OTP_Login:{
        clientId: '1pF0FMt5bRsvdS_tTXH1nfsm9qwa',
        clientType: 'smsOtp'
      },
      Temporary_Login: {
        clientId: 'EeNCQT0_DqSUYR6T56Ho9qfzw2Qa',
        clientType: 'password'
      }
     }
  },
  accessToken: ''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
